"use strict";

exports.__esModule = true;
var _UpdateScheduleScreen = require("./UpdateScheduleScreen");
Object.keys(_UpdateScheduleScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UpdateScheduleScreen[key]) return;
  exports[key] = _UpdateScheduleScreen[key];
});